import { Button, IconButton, Tooltip, useTheme } from "@mui/material";
import { TableSimple } from "components";
import { PageTitle } from "pages/common";
import { SalleModal } from "./SalleModal";
import { useMemo } from "react";
import { useCrudModal } from "hooks/useCrudModal";
import { SalleResource } from "types/caisse.type";
import { useQuery } from "@tanstack/react-query";
import { salleService } from "services";
import { EditTwoTone } from "@ant-design/icons";

export const ListSalle = () => {
  const theme = useTheme();
  const crudModal = useCrudModal<SalleResource>();

  const { data: results, isLoading } = useQuery({
    queryKey: ["salles"],
    queryFn: () => salleService.findAll(),
    staleTime: 1000 * 60 * 60, // 1h
  });

  const columns = useMemo(
    () => [
      {
        Header: "Nom",
        accessor: "libelle",
      },
      {
        Header: "Numero",
        accessor: "numero",
      },
      {
        Header: "Centre",
        accessor: "centre.libelle",
      },
      {
        Header: "Actions",
        accessor: "actions",
        style: { textAlign: "right" },
        className: "text-right",
        Cell: ({ row: { original } }: any) => (
          <div style={{ textAlign: "right" }}>
            <Tooltip title="Modifier la catégorie">
              <IconButton
                color="error"
                size="large"
                onClick={crudModal.onUpdate(original)}
              >
                <EditTwoTone twoToneColor={theme.palette.error.main} />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    ],
    [crudModal, theme.palette.error.main]
  );

  const closeModal = () => {
    crudModal.reset();
  };

  return (
    <div>
      <PageTitle
        title="Salles"
        subtitle="Consulter et gérer les salles"
        sx={{ padding: "1.5rem 0" }}
        right={
          <Button variant="contained" onClick={crudModal.onCreate()}>
            Créer une salle
          </Button>
        }
      />

      <TableSimple
        columns={columns}
        data={results?.data || []}
        loading={isLoading}
        withPagination
        title="Liste des salles"
      />

      {crudModal.isCreateOrUpdate && (
        <SalleModal closeModal={closeModal} value={crudModal.action?.element} />
      )}
    </div>
  );
};
